<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Friends" pageTitle="Friends" />
            <FriendsContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import FriendsContent from '../Friends/FriendsContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'FriendsPage',
    components: {
        MainHeader,
        PageTitle,
        FriendsContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>